/* 2026-09-16 (Claude) - Joel: "have videos show when rolled over". Product card hover video for the
   kit card (snippets/product-grid-item.liquid, .aoam-kc2). The card carries data-kc2-video on its image
   wrap; nothing is requested until a real desktop hover or keyboard focus, then a muted looping clip
   fades in over the photo once frames are actually playing, and pauses on leave. Touch screens,
   reduced motion and Save-Data keep the photo. One delegated listener pair covers every card on the
   page, including cards added later by ajax pagination. The snippet emits this tag once per card with
   a video; the guard below makes every copy after the first a no-op.
   Delete this file and the script tag in product-grid-item.liquid to roll back. */
(function () {
  if (window.__aoamKc2Video) return;
  window.__aoamKc2Video = true;
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function allowed() {
    var c = navigator.connection;
    return hover.matches && !rm.matches && !(c && c.saveData);
  }
  function cardOf(el) {
    return el && el.closest ? el.closest('.aoam-kc2 .grid-item__content') : null;
  }
  function wrapOf(card) {
    return card ? card.querySelector('.grid-product__image-wrap[data-kc2-video]') : null;
  }
  function start(card) {
    var wrap = wrapOf(card);
    if (!wrap || wrap._kc2Dead || !allowed()) return;
    wrap._kc2Want = true;
    clearTimeout(wrap._kc2T);
    var v = wrap._kc2V;
    if (!v) {
      var url = wrap.getAttribute('data-kc2-video');
      if (!/^https:\/\//.test(url || '')) return;
      v = document.createElement('video');
      v.className = 'aoam-kc2__vid';
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      ['muted', 'loop', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
      v.setAttribute('aria-hidden', 'true');
      v.setAttribute('tabindex', '-1');
      v.preload = 'auto';
      v.addEventListener('playing', function () { if (wrap._kc2Want) wrap.classList.add('aoam-kc2--playing'); });
      v.addEventListener('error', function () { wrap._kc2Dead = true; wrap.classList.remove('aoam-kc2--playing'); });
      v.src = url;
      wrap.appendChild(v);
      wrap._kc2V = v;
    }
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () { wrap.classList.remove('aoam-kc2--playing'); });
  }
  function stop(card) {
    var wrap = wrapOf(card);
    if (!wrap) return;
    wrap._kc2Want = false;
    wrap.classList.remove('aoam-kc2--playing');
    var v = wrap._kc2V;
    if (!v) return;
    clearTimeout(wrap._kc2T);
    wrap._kc2T = setTimeout(function () { if (!wrap._kc2Want) v.pause(); }, 380);
  }
  document.addEventListener('mouseover', function (e) {
    var card = cardOf(e.target);
    if (card && !card.contains(e.relatedTarget)) start(card);
  });
  document.addEventListener('mouseout', function (e) {
    var card = cardOf(e.target);
    if (card && !card.contains(e.relatedTarget)) stop(card);
  });
  document.addEventListener('focusin', function (e) { var card = cardOf(e.target); if (card) start(card); });
  /* 2026-09-16 - Joel: "when using the scroll wheel on the mouse and the mouse hovers on a new card it
     doesnt automatically change the color of the card to show its hovered on". Browsers do not re-run
     :hover while the page scrolls under a still pointer, so the card under the cursor stays dark until the
     mouse moves. This remembers the last pointer position and, on each scroll frame, marks the card under
     it with .aoam-kc2--hover (styled the same as :hover in assets/_product-card.css) and starts or stops
     its video. A real mouse move clears the class and hands back to :hover. */
  var px = -1, py = -1, hot = null, raf = 0;
  function mark(card) {
    if (hot === card) return;
    if (hot) { hot.classList.remove('aoam-kc2--hover'); stop(hot); }
    hot = card;
    if (hot) { hot.classList.add('aoam-kc2--hover'); start(hot); }
  }
  document.addEventListener('mousemove', function (e) {
    px = e.clientX; py = e.clientY;
    if (hot) { var c = hot; hot = null; c.classList.remove('aoam-kc2--hover'); if (!c.matches(':hover')) stop(c); }
  }, { passive: true });
  window.addEventListener('scroll', function () {
    if (px < 0 || !hover.matches || raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      mark(cardOf(document.elementFromPoint(px, py)));
    });
  }, { passive: true });
  document.addEventListener('focusout', function (e) {
    var card = cardOf(e.target);
    if (card && !card.contains(e.relatedTarget) && !card.matches(':hover')) stop(card);
  });
})();
